import styled from "styled-components";
import { Content } from "discover.medical.react-component-library";

export const StyledContentBlock = styled(Content.Block)`
  padding-right: ${({ theme }) => theme.space.sm};
`;
